import React, { memo, useCallback, useContext, useMemo } from 'react';
import { Chip } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import { CopilotContext } from '../../../Context';
import { DEFAULT_INPUT_MODE, INPUT_MODE_CONFIG } from '../../../hooks/constants';

const CopilotBarInputModeChip = () => {
    const { t } = useWeb5Context();
    const { copilotBarProps, setCopilotBarProps } = useContext(CopilotContext);

    const inputMode = copilotBarProps?.inputMode ?? DEFAULT_INPUT_MODE;

    const inputModeConfig = useMemo(() => INPUT_MODE_CONFIG[inputMode], [inputMode]);

    const handleRemove = useCallback(
        (event) => {
            event?.stopPropagation?.();

            setCopilotBarProps({
                inputMode: DEFAULT_INPUT_MODE,
                inputPlaceholder: null,
            });
        },
        [setCopilotBarProps],
    );

    if (!inputModeConfig?.showChipInBottomComponent || !inputModeConfig.titleKey) {
        return null;
    }

    return (
        <Chip
            icon={inputModeConfig.icon}
            onRemove={handleRemove}
            onClick={handleRemove}
            type="copilot"
        >
            {t(inputModeConfig.titleKey)}
        </Chip>
    );
};

const MemoizedCopilotBarInputModeChip = memo(CopilotBarInputModeChip);
MemoizedCopilotBarInputModeChip.displayName = 'CopilotBarInputModeChip';

export default MemoizedCopilotBarInputModeChip;
